import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import styles from "./single-verse-slide.css";

import type { SlideState, VerseData } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-single-verse-slide")
export class SingleVerseSlide extends LitElement {
  static styles = styles;

  @property()
  slideState?: SlideState;

  @property()
  verseData?: VerseData;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.verseData) return null;

    return html`
      <bp-scrollable-slide
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">
          ${this.verseData.reference}
          <sup class="translation">
            ${this.verseData.translation +
            (this.verseData.isAdapted ? "*" : "")}
          </sup>
        </div>
        <div slot="content">
          ${unsafeHTML(this.verseData.text)}
          ${this.verseData.isAdapted
            ? html`<div class="caption">*Key Words Adapted by Teacher</div>`
            : ""}
        </div>
      </bp-scrollable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-single-verse-slide": SingleVerseSlide;
  }
}
